// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qzF4","title":"styles_title__3gcBR"};